"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterView = exports.Registers = exports.RegisterEntry = void 0;
const RegisterEntry_yaml_component_1 = __importDefault(require("./RegisterEntry.yaml?component"));
exports.RegisterEntry = RegisterEntry_yaml_component_1.default;
const Registers_yaml_component_1 = __importDefault(require("./Registers.yaml?component"));
exports.Registers = Registers_yaml_component_1.default;
const RegisterView_yaml_component_1 = __importDefault(require("./RegisterView.yaml?component"));
exports.RegisterView = RegisterView_yaml_component_1.default;
__exportStar(require("./form"), exports);
__exportStar(require("./primitives"), exports);
